// extracted by mini-css-extract-plugin
export var productImage = "_mn-1";
export var viewLink = "_mn-2";
export var wishlistItem = "_mn-0";